import { styled } from "@mui/material/styles";
import YouTube, { YouTubeProps } from "react-youtube";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import MxTypography from "@/src-refactor/modules/shared/components/refactor/components/l1/MxTypography";
import { EFontFamilies } from "@/shared/theme/theme";
import { Grid } from "@mui/material";
import MxDetailCard from "@rf-l1/page/details/MxDetailCard";

const MxYouTubeVideos = () => {
  const { videos } = usePropertyDetailPage();

  const opts: YouTubeProps["opts"] = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0
    }
  };

  if (!videos.length) return <></>;

  return (
    <MxDetailCard>
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <MxTypography
            variant="h5"
            color="primary"
            fontFamily={EFontFamilies.DISPLAY}
          >
            Videos
          </MxTypography>
        </Grid>
        <Grid container item xs={12} spacing={2}>
          {videos.map(item => (
            <Grid item xs={12} md={6} key={item}>
              <BoxTypeVideo>
                <YouTube videoId={item ?? ""} opts={opts} />
              </BoxTypeVideo>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </MxDetailCard>
  );
};

export default MxYouTubeVideos;

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "20px",
  border: "1px solid #ccc",
  borderRadius: "20px",
  background: "#fff",
  padding: "50px 40px"
}));

const BoxTypeVideo = styled("div")(({ theme }) => ({
  width: "100%",
  height: "285px",
  background: "transparent",
  borderRadius: "26px",
  "& div": {
    width: "100%",
    height: "100%"
  },
  "& iframe": {
    width: "100%",
    height: "100%",
    borderRadius: "26px"
  },

  [theme.breakpoints.down("md")]: {
    height: "309px",
    right: "30px"
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    position: "initial",
    marginTop: "-60px"
  }
}));

const ContainerVideos = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "10px",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: "35px",
  rowGap: "35px",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(1, 100%)"
  }
}));
